import React, {FC} from 'react'
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { AppStateType } from "../../../../redux/reducers";
import {
    Box,
    Dialog,
    DialogTitle,
    Divider as MuiDivider,
    CircularProgress, Backdrop,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import { fetchUnitImages, partialUpdateUnitImage } from '../../../../redux/actions/unitImagesActions'
import { useTranslation } from "react-i18next";
import {IconButton, useMediaQuery, useTheme} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import DefaultDropzone from "./components/DefaultDropzone";
import Loading from "../../../../components/Loading";
import {A11yUnit} from "../../../../models/utils";
import {AccessibilityUnit} from "../../../../models/AccessibilityUnits";

const Divider = styled(MuiDivider)(spacing);

const TopBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .MuiButtonBase-root {
        width: 57px;
    }
`

type UnitImagesProps = {
    open: boolean;
    onClose: () => void;
    unit: any
}

const UnitImagesDialog: FC<UnitImagesProps> = ({open, onClose, unit}) => {
    const theme = useTheme();
    const dispatch = useDispatch()
    const property: any = useSelector((state: AppStateType) => state.propertyReducer.property)
    const a11yStandardValues = useSelector((state: AppStateType) => state.a11yStandardReducer.a11yStandard)
    const a11yStandard = a11yStandardValues.find((item) => item.key === property.a11y_standard)
    const images: any = useSelector((state: AppStateType) => state.unitImagesReducer.unitImages)
    const user: any = useSelector((state: AppStateType) => state.authReducer.user)
    const a11yes: any = useSelector((state: AppStateType) => state.a11yesReducer.a11yes);
    const unitStandard: A11yUnit = a11yStandard && unit ? a11yStandard.values.find((el: any) => el.key === unit.type) : [];
    const isNotDesktop = useMediaQuery(theme.breakpoints.down('md'));
    const [loading, setLoading] = useState({open: false, cancel: false})
    const [abortController, setAbortController] = useState(new AbortController())

    const cancelLoading = () => {
        abortController.abort()
        setLoading({...loading, open: false})
    }

    const handlerLoading = (loading: boolean, cancel: boolean = false) => {
        setLoading({open: loading, cancel: cancel})
    }

    useEffect(() => {
        a11yes.sort((a: any, b: any) => a.attribute.localeCompare(b.attribute))
    }, [a11yes])

    const handleTypeChange = (e: any) => {
        const imageIndex = images.findIndex((image: any) => image.id === e.currentImage.id);
        const data = {
            items: e.items
        }
        dispatch(partialUpdateUnitImage(imageIndex, e.currentImage.id, data, user.token))
    }

    useEffect(() => {
        if (unit && unit.id) {
            dispatch(fetchUnitImages(unit.id, user.token))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unit])

    if (!unit) {
        return null
    }

    return (
        <Dialog
            fullScreen={isNotDesktop}
            onClose={onClose}
            fullWidth={true}
            aria-labelledby="start-classifying-dialog"
            open={open}
            maxWidth={'md'}
        >
            <TopBar>
                <DialogTitle>{`${!isNotDesktop ? 'Insert pictures for:' : ''} ${unit.title}`}</DialogTitle>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onClose}
                  aria-label="close"
                >
                    <CloseIcon/>
                </IconButton>
            </TopBar>
            <Divider />
            <DefaultDropzone
              handleClose={onClose}
              unit={unit}
              user={user}
              unitStandard={unitStandard}
              a11y={a11yes}
              handleTypeChange={handleTypeChange}
              onLoading={handlerLoading}
              onSetAbortController={setAbortController}
            />
            <Loading
              open={loading.open}
              cancelButton={loading.cancel}
              onClick={cancelLoading}
            />
        </Dialog>
    );
}

export default UnitImagesDialog
